<template>
    <div class="seccion-datos">
        <h4><i class="fas fa-id-card icono-simple"></i> Información Personal</h4>
        <div class="form-perfil">
            <div class="form-row">
                <div class="form-group">
                    <label><i class="fas fa-user"></i> Apellidos</label>
                    <input
v-if="isEditing" v-model="perfilEditado.last_name" type="text" class="form-control"
                        placeholder="Ej. Pérez García" />
                    <p v-else class="form-value">{{ datosPaciente.last_name || 'No especificado' }}
                    </p>
                </div>
                <div class="form-group">
                    <label><i class="fas fa-user"></i> Nombres</label>
                    <input
v-if="isEditing" v-model="perfilEditado.first_name" type="text" class="form-control"
                        placeholder="Ej. Juan Carlos" />
                    <p v-else class="form-value">{{ datosPaciente.first_name || 'No especificado' }}
                    </p>
                </div>
            </div>
            <div class="form-row">
                <div class="form-group">
                    <label><i class="fas fa-birthday-cake"></i> Fecha de Nacimiento</label>
                    <DatePicker
v-if="isEditing" v-model="perfilEditado.birthdate"
                        placeholder="Seleccionar fecha de nacimiento" :max-date="new Date().toISOString().split('T')[0]"
                        :errors="{}" error-field-name="birthdate" />
                    <p v-else class="form-value">{{ formatearFechaNacimiento() }}</p>
                </div>
                <div class="form-group">
                    <label><i class="fas fa-venus-mars"></i> Género</label>
                    <GenderSelect
v-if="isEditing" v-model="perfilEditado.gender" placeholder="Seleccionar género"
                        :errors="{}" error-field-name="gender" />
                    <p v-else class="form-value">{{ formatearGenero() }}</p>
                </div>
            </div>
            <div class="form-row">
                <div class="form-group">
                    <label><i class="fas fa-phone"></i> Teléfono (WhatsApp)</label>
                    <input
v-if="isEditing" v-model="perfilEditado.whatsapp" type="text" class="form-control"
                        placeholder="Ej. +52 55 1234 5678" />
                    <p v-else class="form-value">{{ datosPaciente.whatsapp || 'No especificado' }}
                    </p>
                </div>
                <div class="form-group">
                    <label><i class="fas fa-envelope"></i> Email</label>
                    <template v-if="isEditing">
                        <input
v-model="perfilEditado.email" type="email" class="form-control"
                            :class="{ 'is-invalid': emailInvalido && emailTocado }" autocomplete="email"
                            inputmode="email" pattern="^[^\s@]+@[^\s@]+\.[^\s@]{2,}$" placeholder="Ej. juan@email.com"
                            @input="onEmailInput && onEmailInput()" @blur="onEmailBlur && onEmailBlur()" />
                        <div v-if="emailInvalido && emailTocado" class="invalid-feedback">
                            Ingresa un correo electrónico válido.
                        </div>
                    </template>
                    <p v-else class="form-value">{{ datosPaciente.email || 'No especificado' }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { defineProps, toRefs } from 'vue';
import DatePicker from '@/components/DatePicker.vue';
import GenderSelect from '../Forms/Common/GenderSelect.vue';

const props = defineProps({
    isEditing: {
        type: Boolean,
        default: false
    },
    perfilEditado: {
        type: Object,
        required: true
    },
    datosPaciente: {
        type: Object,
        required: true
    },
    emailInvalido: {
        type: Boolean,
        default: false
    },
    emailTocado: {
        type: Boolean,
        default: false
    },
    formatearFechaNacimiento: {
        type: Function,
        required: true
    },
    formatearGenero: {
        type: Function,
        required: true
    },
    onEmailInput: {
        type: Function,
        default: null
    },
    onEmailBlur: {
        type: Function,
        default: null
    }
});

const {
    isEditing,
    perfilEditado,
    datosPaciente,
    emailInvalido,
    emailTocado,
    formatearFechaNacimiento,
    formatearGenero,
    onEmailInput,
    onEmailBlur
} = toRefs(props);
</script>

<style scoped>
/* ===== ESTILOS DE FORMULARIO - DISEÑO EJECUTIVO ===== */

.seccion-datos {
    margin-bottom: 2rem;
}

.seccion-datos h4 {
    font-size: 1rem;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 1.5rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    border-bottom: 1px solid #e2e8f0;
    padding-bottom: 0.75rem;
}

.icono-simple {
    color: #3b82f6;
    font-size: 1.1rem;
}

/* Contenedor del Formulario del Perfil - Compacto */
.form-perfil {
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
}

/* Fila de Formulario - Grid Compacto */
.form-row {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1.5rem;
}

/* Campo Individual - Compacto y Formal */
.form-group {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

/* Etiqueta - Compacta y Formal */
.form-group label {
    font-size: 0.7rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.8px;
    color: #64748b;
    margin-bottom: 0;
    display: flex;
    align-items: center;
    gap: 0.35rem;
}

/* Iconos - Azul Profesional */
.form-group label i {
    font-size: 0.75rem;
    width: 0.85rem;
    text-align: center;
    color: #1e40af;
}

/* ===== MODO VISTA - COMPACTO Y FORMAL ===== */

.form-value {
    font-size: 0.925rem;
    font-weight: 500;
    color: #1e293b;
    padding: 0.5rem 0;
    margin-top: 0;
    border: none;
    border-bottom: 1px solid rgba(15, 23, 42, 0.1);
    background: transparent;
    line-height: 1.4;
    letter-spacing: 0.15px;
    min-height: 2rem;
    display: flex;
    align-items: center;
    transition: all 0.3s ease;
}

.form-value:hover {
    border-bottom-color: rgba(30, 64, 175, 0.25);
    color: #0f172a;
}

.form-value:empty::before {
    content: "Sin registro";
    color: #cbd5e1;
    font-weight: 400;
    font-style: italic;
    font-size: 0.875rem;
}

/* Responsive */
@media (max-width: 768px) {
    .form-row {
        grid-template-columns: 1fr;
        gap: 1.25rem;
    }
}
</style>
